import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import { MenuItemModel } from "../../types/MenuItemModel";

export interface MenuItemProps {
    menuItem: MenuItemModel
}

const MenuItem: React.FC<MenuItemProps> = ({ menuItem }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const location = useLocation();

    function activeRoute(routeName) {
        return location.pathname.indexOf(routeName) > -1 ? "active" : "";
    };

    function createChildMenus(menuitems) {
        return menuitems.map((menuitem, key) => {
            return <MenuItem menuItem={menuitem} key={menuitem.id} />;
        });
    }

    if (menuItem.childMenuItems && menuItem.childMenuItems.length > 0) {
        if (menuItem.title === "")
            return createChildMenus(menuItem.childMenuItems);

        return (
            <li className={isOpen ? "active" : ""} key={menuItem.id}>
                <a className="nav-link" onClick={e => { e.preventDefault(); setIsOpen(!isOpen); }}>
                    <i className={menuItem.simpleLineIcon} />
                    <p>{menuItem.title}<b className={isOpen ? "caret rotate-180" : "caret"} /></p>
                </a>
                <Collapse in={isOpen}>
                    <ul className="nav">{createChildMenus(menuItem.childMenuItems)}</ul>
                </Collapse>
            </li>
        )
    }

    if (menuItem.navigateUrl) {
        return (
            <li className={activeRoute('/plm' + menuItem.navigateUrl)} key={menuItem.id}>
                <NavLink
                    className="nav-link"
                    state={{ title: menuItem.title, fromMenu: true }}
                    to={{ pathname: '/plm' + menuItem.navigateUrl }}
                >
                    {menuItem.simpleLineIcon
                        ? (<><i className={menuItem.simpleLineIcon} /><p>{menuItem.title}</p></>)
                        : (<><span className="sidebar-mini">{menuItem.title.substring(0, 1)}</span><span className="sidebar-normal">{menuItem.title}</span></>)
                    }
                </NavLink>
            </li>
        )
    }

    return menuItem.id + "test ";
}
export default MenuItem;